import { Controller } from "@hotwired/stimulus"

// Toggles visibility of a target element (by id) based on checkbox state.
// Attach to the checkbox and provide data-toggle-visibility-target-id.
export default class extends Controller {
    static values = { targetId: String }

    connect() {
        this.sync()
    }

    update() {
        this.sync()
    }

    sync() {
        const target = this.targetElement()
        if (!target) return
        const checked = this.element.checked ?? this.element.matches(":checked")
        target.classList.toggle("d-none", !checked)
    }

    targetElement() {
        if (this.hasTargetIdValue) {
            return document.getElementById(this.targetIdValue)
        }
        return null
    }
}

